module.exports = __webpack_public_path__ + "img/522-42dfb3.png";